<template>
  <v-dialog v-model="yourArticleInfoDialog" width="800">
    <v-card v-if="$vuetify.breakpoint.smAndUp">
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <span class="display-1 text-uppercase font-weight-bold">{{$t('infoDialogs.private.yourArticles.Title')}}</span>
        <v-spacer></v-spacer>
        <v-btn color="error" :title="$t('sideDialogs.private.yourArticles.Close window')" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p class="pr-5 text--primary title">{{$t('infoDialogs.private.yourArticles.PageDescription')}}.</p>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-row class="mt-10">
          <v-col md="12">
            <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.yourArticles.PageActionsOne')}}</span>
            <span class="ml-5"><v-icon large>far fa-edit</v-icon></span>
          </v-col>
          <!-- <v-col md="12" class="mt-5">
            <span class="body-1 text--primary font-weight-bold">Nederst på artikkelen kan du se hvor mange som har åpnet artikkelen</span>
          </v-col>
          <v-col md="12" class="mt-5">
            <span class="body-1 text--primary font-weight-bold">Du kan også se hvor mange kommentarer som har blitt skrevet, og klikke på tallet for å lese dem</span>
          </v-col> -->
        </v-row>
      </v-card-text>
    </v-card>
    <!--Phone-->
    <v-card v-else>
      <v-row class="ma-0 pa-0">
        <!--Title and close button-->
        <v-col cols="12" class="py-0">
          <v-row>
            <v-col cols="7" class="py-0 pt-3 pl-6">
              <span class="title text-uppercase font-weight-bold">{{$t('infoDialogs.private.yourArticles.Title')}}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="py-0">
              <v-btn color="error" :title="$t('sideDialogs.private.yourArticles.Close window')" class="ma-2" outlined icon large @click="closeDialog">
                <v-icon>close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <!--Description-->
        <v-col cols="12">
          <span class="pr-5 text--primary title">{{$t('infoDialogs.private.yourArticles.PageDescription')}}.</span>
        </v-col>
        <!--Edit Article with icon-->
        <v-col cols="12">
          <v-row>
            <!--Edit description-->
            <v-col cols="8">
              <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.yourArticles.PageActionsOne')}}</span>
            </v-col>
            <!--Edit icon-->
            <v-col>
              <v-btn icon>
                <v-icon large>far fa-edit</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <!--Seen-->
        <v-col cols="12">
          <span>Nederst på artikkelen kan du se hvor mange som har åpnet artikkelen</span>
        </v-col>
        <!--Comments-->
        <v-col cols="12">
          <span>Du kan også se hvor mange kommentarer som har blitt skrevet, og klikke på tallet for å lese dem</span>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
// Import the i18n - This may need to be modified
import messages from "../../modules/lang/export";
export default {
  // Communicate with i18n
  i18n: { messages },
  data(){
    return{
      // Define the dialog v-model that we are using
      yourArticleInfoDialog:false,
    }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog() {
      this.yourArticleInfoDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.yourArticleInfoDialog = false;
    }
  }
}
</script>